import {ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit} from '@angular/core';
import {TableComponent} from '../../../components/table/table.component';
import {AuthenticatedBaseComponent} from '../../authenticated-base.component';
import {TabSwitcherComponent} from '../../../components/tab-switcher/tab-switcher.component';
import {Backend} from '@generated-backend-types';
import {TranslateService} from '@ngx-translate/core';
import {ContentHeaderService} from '../../../services/content-header.service';
import {TitleService} from '../../../services/title.service';
import {ActivatedRoute} from '@angular/router';
import {takeUntil} from 'rxjs';
import Patient = Backend.App.Resources.Dashboard.Patient;

@Component({
  selector: 'app-authenticated-patients-authentication-audit-log',
  templateUrl: 'authentication-audit-log.component.html',
  standalone: true,
  imports: [
    TableComponent,
    TabSwitcherComponent
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AuthenticationAuditLogComponent extends AuthenticatedBaseComponent implements OnInit {
  public patient?: Patient;

  public constructor(
    protected override readonly cdr: ChangeDetectorRef,
    protected override readonly translate: TranslateService,
    protected override readonly contentHeaderService: ContentHeaderService,
    protected override readonly titleService: TitleService,
    private readonly activatedRoute: ActivatedRoute,
  ) {
    super(cdr, translate, contentHeaderService, titleService);
  }

  public ngOnInit() {
    this.activatedRoute.data.pipe(takeUntil(this.onDestroy$)).subscribe(data => {
      const patient: Patient | undefined = data['patient'];

      if (patient) {
        this.patient = patient;
        this.cdr.markForCheck();
      }

      this.titleService.setTitle('authenticated.patients.history.title');
    });
  }

}
